module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-switch",
    class: _vm.newClasses
  }, [_c('label', {
    staticClass: "form-switch--label",
    attrs: {
      "for": 'switch-' + _vm.name
    }
  }, [_vm._v(_vm._s(_vm.$t(_vm.newLabel)))]), _vm._v(" "), _c('div', {
    staticClass: "switch-container",
    attrs: {
      "id": 'switch-' + _vm.name
    },
    on: {
      "click": _vm.valueSwitch
    }
  }, [_c('div', {
    staticClass: "switch-button"
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-afd7a816","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/helpers/DataInput/FormSwitch.vue
// module id = 1975
// module chunks = 0